import "./services.css";
import { ServiceCategoryItem } from "../serviceItem/ServiceCategoryItem";
import { servicesCategories } from "./../../barberData";

export const Services = () => {
  return (
    <div className="servicesWrapper" id="sluzby">
      <div className="services">
        <h1 className="sluzby">SLUŽBY A CENY</h1>
        <hr className="headerUnderline" />
        
        
        <span className="priceDivisionNotificationContainer">
          <em className="priceDivisionNotification">
            Ceny jsou uvedeny ve formátu Master / Regular / Junior a jsou platné od 10. února 2026
          </em>
          <p>
            Ke všem službám je voda a parfém samozřejmostí
          </p>
          <p>
            Po každém střihu získáváte styling zdarma
          </p>            
        </span>
        {servicesCategories.map((serviceCategory) => (
          <ServiceCategoryItem
            serviceCategory={serviceCategory}
            key={serviceCategory.id}
          />
        ))}

      </div>
    </div>
  );
};
